<template>
  <div class="notification">
    <component
      :is="component"
      :notification="notification"
      @hide="hideNotification" />
  </div>
</template>

<script>
import NotificationsItemChats from './NotificationsItemChats.vue';
import NotificationsItemAdmin from './NotificationsItemAdmin.vue';
import NotificationsItemSimple from './NotificationsItemSimple.vue';
import NotificationsItemUser from './NotificationsItemUser.vue';
import NotificationsItemError from './NotificationsItemError.vue';

export default {
  name: 'NotificationsItem',

  components: {
    NotificationsItemChats,
    NotificationsItemAdmin,
    NotificationsItemSimple,
    NotificationsItemUser,
    NotificationsItemError,
  },

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  computed: {
    component() {
      return `notifications-item-${this.notification.entity}`;
    },
  },

  methods: {
    hideNotification(notificationId) {
      this.$emit('hide', notificationId);
    },
  },
};
</script>

<style lang="scss" scoped>
  .notification {
    --padding: 15px 40px 25px;
    --background-color: #{$color--basic-dark-gray};

    min-width: 180px;
    max-width: 300px;
    font-size: 1.2rem;
    background-color: var(--background-color);
    padding: var(--padding);
    border-radius: 10px;
    position: relative;
  }

  .notification__header {
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  .notification__close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 8px;
    transform: translate(50%, -50%);
    cursor: pointer;
  }

  .notification__body {
    margin: 16px 0;
    max-height: 62px;
    min-height: 31px;
    display: flex;
    overflow: hidden;
    align-items: flex-start;
    justify-content: space-between;
  }

  .notification__link {
    color: $color--basic-blue;
    transition: color .15s ease;
  }

  .notification__unread {
    background: $color--cherry-red;
    flex: 0 0 26px;
    height: 26px;
    line-height: 28px;
    text-align: center;
    font-size: 1rem;
    border-radius: 50%;
    letter-spacing: 1px;
    margin-left: 12px;
    font-weight: 500;
  }

  .notification__footer {
    display: flex;
    justify-content: space-around;
  }

  @media screen and #{$screen-less-than-1024} {
    .notification {
      --background-color: transparent;

      width: 100%;
      max-width: initial;
      border-radius: 0;
    }
  }
</style>
